import { useStore } from 'zustand';

import FileDropperInput from './_image_wizard/FileDropperInput';
import ImageCropperInput from './_image_wizard/ImageCropperInput';
import HoneybadgerWrapper from '../honeybadger/HoneybadgerWrapper';

export default function ImageWizard({ imageStore, handleCallback = null, endpoints }) {
  const page = useStore(imageStore, (state) => state.page);

  return (
    <HoneybadgerWrapper>
      <div className="file-selector-container">
        {page === 0 && <FileDropperInput {...{ imageStore }} />}
        {page === 1 && <ImageCropperInput {...{ imageStore, endpoints, handleCallback }} />}
      </div>
    </HoneybadgerWrapper>
  );
}
